import {
    DELETE_SERVICE_PLAN_ERROR,
    DELETE_SERVICE_PLAN_START,
    DELETE_SERVICE_PLAN_SUCCESS
} from "../../constants";
import showToaster from "../../helpers/toasterMessages/showToaster";
import { deleteServicePlans, getUserServicePlan as query } from "../../lib/graphql";

export function deleteServicePlan(id) {
    return async (dispatch, getState, { client }) => {
        dispatch({ type: DELETE_SERVICE_PLAN_START });
        try {

            const { data: getPurchaseData } = await client.query({
                query,
                variables: {
                    servicePlanId: Number(id),
                },
                fetchPolicy: 'network-only'

            });

            if (getPurchaseData?.getUserServicePlan?.status == 200 && getPurchaseData?.getUserServicePlan?.results?.length > 0) {
                return showToaster({ messageId: 'unEnableServicePlan', toasterType: 'error' })
            }

            const { data } = await client.mutate({
                mutation: deleteServicePlans,
                variables: { id },
            });
            if (data?.deleteServicePlan?.status == 200) {
                dispatch({
                    type: DELETE_SERVICE_PLAN_SUCCESS
                });
                showToaster({ messageId: 'deleteServicePlansSuccess', toasterType: 'success' });
                return true;
            } else {
                dispatch({
                    type: DELETE_SERVICE_PLAN_ERROR
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.deleteServicePlan?.errorMessage })
            }

        } catch (error) {
            dispatch({
                type: DELETE_SERVICE_PLAN_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
        }
    }
};